import { apiService } from '../../shared/services/apiService';
import { SuggestionScenariosInfo } from '../interfaces/suggestionScenariosInfo';

type GetSuggestionForUserParams =
  | {
      date?: string; // if not provided, get info for last scan
    }
  | {
      startScanId?: number;
      endScanId?: number;
    };

export const scenariosService = {
  async getSuggestionForUser(customerId: number, params?: GetSuggestionForUserParams) {
    const resp = await apiService.get<SuggestionScenariosInfo>(
      `/api/coach/scenario/${customerId}`,
      { params },
    );
    return resp.data;
  },
};
